import { user_addresses } from "@core/gql-mockups/addresses";

const { minimize_str } = require("@core/helpers/string");

export const HAS_USER = minimize_str(`
  mutation ($input: HasUserInput) {
  result: hasUser(input: $input)
  }
`);

export const REGISTER_SEND_SMS = minimize_str(`
  mutation ($input: UserRegisterSendSmsInput!) {
    result: registerSendSMS(input: $input) {
      message
      success
    }
  }
`);

export const LOGIN_SEND_SMS = minimize_str(`
  mutation ($mobile: String!, $create_if_not_exists: Boolean, $captcha: String) {
   result: loginSendSMS(mobile: $mobile, create_if_not_exists: $create_if_not_exists, captcha: $captcha) {
      message
      success
    }
  }
`);

export const SMS_LOGIN_VERIFY_TOKEN = minimize_str(`
  mutation ($mobile:String, $token: String, $captcha: String, $input: UserSMSLoginVerifyTokenInput) {
   result: SMSLoginVerifyToken(mobile: $mobile, token: $token, captcha: $captcha, input:$input) {
      token
      user { access_id }
    }
  }
`);

export const LOGIN = minimize_str(`
  mutation($input: UserLoginInput) {
    result: login(input: $input) {
      token
      user { access_id }
    }
  }
`);

export const REGISTER = minimize_str(`
  mutation ($input: UserRegisterInput) {
  result: register(input: $input) {
      token
      user { access_id }
    }
  }
`);

export const RESET_PASSWORD_SEND_EMAIL = minimize_str(`
  mutation ($email:String) {
  result: resetPasswordSendEmail(email:$email) {
      message
      success
    }
  }
`);

export const RESET_PASSWORD_VERIFY = minimize_str(`
  mutation ($input:resetPasswordVerifyInput) {
  result: resetPasswordVerify(input:$input) {
      message
      success
      extra_data
    }
  }
`);

export const UPDATE_USER = minimize_str(`
  mutation($input: updateUserInput!) {
   result: updateUser(input: $input) {
      message
      success
    }
  }
`);

export const UPDATE_COMPANY = minimize_str(`
  mutation($input: CompanyInput , $id: ID) {
   result: updateCompany(input: $input, id : $id) {
     id
    }
  }
`);

export const CHANGE_PASSWORD = minimize_str(`
  mutation($input: changePasswordInput!) {
   result: changePassword(input: $input) {
      message
      success
    }
  }
`);

export const RESET_PASSWORD_SEND_SMS = minimize_str(`
  mutation($mobile:String) {
   result: resetPasswordSendSMS(mobile: $mobile) {
      message
      success
    }
  }
`);


export const UPDATE_USER_IDENTITY = minimize_str(`
  mutation($input: updateUserIdentityInput) {
   user: updateUserIdentity(input: $input) {
      message
      success
    }
  }
`);

export const UPDATE_USER_IDENTITY_WITH_ADDRESS = minimize_str(`
  mutation($input: updateUserIdentityInput, $address_input: UserAddressInput) {
   user: updateUserIdentity(input: $input) {
      message
      success
    }
    address: createUserAddress(input: $address_input) ${user_addresses}
  }
`);

export const UPDATE_USER_MOBILE_SEND_SMS = minimize_str(`
  mutation($mobile: String) {
   result: updateUserMobileSendSMS(mobile: $mobile) {
      message
      success
    }
  }
`);

export const UPDATE_USER_MOBILE_VERIFY_SMS = minimize_str(`
  mutation($mobile: String, $code: String) {
   result: updateUserMobileVerifySMS(mobile: $mobile, code: $code) {
      message
      success
    }
  }
`);

/*
 * 3 step mobile change flow.
 * The code now goes to the CURRENT mobile (proof the session owns the number it
 * already has), so this mutation takes no `mobile` argument. Kept next to
 * UPDATE_USER_MOBILE_SEND_SMS instead of replacing it so sites that still talk
 * to an older api keep working.
 */
export const UPDATE_USER_MOBILE_SEND_SMS_V2 = minimize_str(`
  mutation($captcha: String) {
   result: updateUserMobileSendSMS(captcha: $captcha) {
      message
      success
      extra_data
    }
  }
`);

// step 2: verify the code sent to the current mobile and claim the new number,
// which then gets a code of its own (confirmed with UPDATE_USER_MOBILE_VERIFY_SMS).
export const UPDATE_USER_MOBILE_VERIFY_CURRENT_SMS = minimize_str(`
  mutation($code: String, $mobile: String, $captcha: String) {
   result: updateUserMobileVerifyCurrentSMS(code: $code, mobile: $mobile, captcha: $captcha) {
      message
      success
    }
  }
`);
